// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1nCV8","info":"UpdateTermsInfo_info__3idkg"};